module.exports = __webpack_public_path__ + "static/media/16UNODC8.94b3b167.jpg";